import type { ComponentProps, PropsWithChildren } from 'react';
import clsx from 'clsx';

export type Props = PropsWithChildren<{
    sort?: 1 | -1 | null | number,
} & ComponentProps<'div'>>;

function Header({ children, className, sort, ...attrs }: Props) {
    return (
        <div {...attrs} className={clsx(
            "d-flex justify-content-between py-2 mx-n2 px-2",
            sort !== undefined && "text-hover-inverse-secondary bg-hover-secondary rounded",
            className
        )}>
            {children}
            {sort !== null && sort === -1 && <i className="bi bi-caret-down-fill pt-1"></i>}
            {sort !== null && sort === 1 && <i className="bi bi-caret-up-fill pt-1"></i>}
        </div>
    );
}

export default Header;
